import React from "react"

type Props = {
    setting     : any
    isSelected  : boolean
    onClick     : callback
}
export default function SearchSettingOption(props:Props) {
    const onClick = () => {
        if (props.onClick && props.setting.canAccess) props.onClick(props.setting.url || props.setting.settingsUrl)
    }

    const iconClass = Classes('icon-22', 'm-r-10', props.setting.svgIcon, !props.setting.canAccess ? "disabled" : "")
    const icon= <div className={iconClass}/>

    const classes = Classes("row ui5-list-item", {
        'selected': props.isSelected,
    })

    return (
        <div className={classes} onClick={onClick}>
            <div className="cell">
                <div className="title">
                    {icon}
                    <div className="ui5-txt-default max-w-250">{props.setting.name || props.setting.module.name}</div>
                    {!props.setting.canAccess && <div className="ui5-txt-not-important m-l-10"> (No access) </div>}
                </div>
            </div>
            <div className="cell align-r"/>
        </div>
    )
}
